import { useContext } from "react";

import { CardContext } from "./context";

const useCardContext = () => {
  const context = useContext(CardContext);
  if (!context) {
    throw new Error("useCardContext must be used within CardContextProvider!");
  }

  return context;
};

export default useCardContext;
